var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.81346 11.2207C9.25596 11.2207 8.70012 11.0365 8.23512 10.6682L4.49762 7.65483C4.22846 7.43817 4.18679 7.044 4.40262 6.77567C4.62012 6.50817 5.01346 6.46567 5.28179 6.6815L9.01596 9.6915C9.48512 10.0632 10.146 10.0632 10.6185 9.68817L14.3151 6.68317C14.5835 6.464 14.9768 6.50567 15.1951 6.774C15.4126 7.0415 15.3718 7.43483 15.1043 7.65317L11.401 10.6632C10.9326 11.0348 10.3726 11.2207 9.81346 11.2207Z",
    fill: "#313131"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_358_8874",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 19,
    height: 17
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.833008 1.66667H18.7496V17.9167H0.833008V1.66667Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_358_8874)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.69884 16.6667H13.8822C13.8838 16.665 13.8905 16.6667 13.8955 16.6667C14.8463 16.6667 15.6897 16.3267 16.3363 15.6808C17.0872 14.9333 17.4997 13.8592 17.4997 12.6567V6.93334C17.4997 4.60584 15.978 2.91667 13.8822 2.91667H5.70051C3.60467 2.91667 2.08301 4.60584 2.08301 6.93334V12.6567C2.08301 13.8592 2.49634 14.9333 3.24634 15.6808C3.89301 16.3267 4.73717 16.6667 5.68717 16.6667H5.69884ZM5.68467 17.9167C4.39884 17.9167 3.25051 17.45 2.36384 16.5667C1.37634 15.5817 0.833008 14.1933 0.833008 12.6567V6.93334C0.833008 3.93084 2.92551 1.66667 5.70051 1.66667H13.8822C16.6572 1.66667 18.7497 3.93084 18.7497 6.93334V12.6567C18.7497 14.1933 18.2063 15.5817 17.2188 16.5667C16.333 17.4492 15.1838 17.9167 13.8955 17.9167H13.8822H5.70051H5.68467Z",
    fill: "#313131"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail-icon.8327ffe3b525d992b051c4b4f27452de.svg";
export { ForwardRef as ReactComponent };